import { render, staticRenderFns } from "./clientapilist.vue?vue&type=template&id=2ca8635b"
import script from "./clientapilist.vue?vue&type=script&lang=js"
export * from "./clientapilist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports